
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.268 4.232l.53-.53-.53.53zM6.5 21.535v.75a.75.75 0 00.53-.22l-.53-.53zm-3.5 0h-.75c0 .415.336.75.75.75v-.75zm0-3.57l-.53-.53a.75.75 0 00-.22.53H3zM15.762 5.201a.75.75 0 00-1.06 1.06l1.06-1.06zm2.475 4.596a.75.75 0 101.061-1.06l-1.06 1.06zm-.974-5.035a1.75 1.75 0 012.474 0l1.061-1.061a3.25 3.25 0 00-4.596 0l1.06 1.06zm2.474 0a1.75 1.75 0 010 2.474l1.061 1.061a3.25 3.25 0 000-4.596l-1.06 1.06zm0 2.474L5.97 21.005l1.06 1.06L20.798 8.299l-1.06-1.06zM6.5 20.786H3v1.5h3.5v-1.5zm9.702-17.084L2.47 17.434l1.06 1.06L17.262 4.764l-1.06-1.061zM2.25 17.964v3.572h1.5v-3.572h-1.5zM14.702 6.263l3.535 3.535 1.061-1.06-3.535-3.536-1.061 1.06z"}})])
          )
        }
      }
    